import { atom } from 'jotai'
import { SelectedEntityType } from 'src/v2/types/core'
import { browserLogger } from 'src/utils/browser-logger'

import * as coreAtoms from 'src/v2/state/core'
import * as searchAtoms from 'src/v2/state/map-explorer/search'

export type MapExplorerSidebarState = SelectedEntityType | 'RESULTS' | 'EMPTY'

// For checking when search results are available or not
export const searchResultsState = atom<Promise<MapExplorerSidebarState>>(async (get) => {
  const results = await get(searchAtoms.searchResults)
  return results ? 'RESULTS' : 'EMPTY'
})

// For checking when an entity is selected or not
export const selectedEntityState = atom<Promise<MapExplorerSidebarState>>(async (get) => {
  const selectedEntity = await get(coreAtoms.selectedEntity)

  if (selectedEntity) {
    browserLogger.info('Selected entity is type', selectedEntity.type)
    return selectedEntity.type
  }

  return 'EMPTY'
})
